const info = 
{
    title: "Drowning Man",
    type: "Novel"
};

export default info;